<template>
    <div class="bg-white px-3">
        <div>
            <el-row :gutter="20" class="my-3">
                <el-col :span="24">
                    <el-card class="box-card" shadow="never" v-for="(tip,ti) in yhzl" :key="ti">
                        <div slot="header" class="clearfix">
                            <span class="tiptit">{{tip.title}}</span>
                            <el-button icon="el-icon-refresh " class="shuaxin_icon" title="刷新" size="mini"
                                @click="getdata(1)" circle></el-button>
                        </div>
                        <div class="row">
                            <div class="tiplist" v-for="(tlist,listi) in tip.list" :key="listi">
                                <button class="btn btn-light w-100 ssbtns">
                                    <h4 class="mb-1 numbs">{{tlist.value}}</h4>
                                    <small class="text-muted">
                                        {{tlist.name}}</small>
                                </button>
                            </div>
                        </div>
                    </el-card>
                </el-col>

            </el-row>
        </div>
        <div class="add_tits" ref="titles">
            <el-form :inline="true" class="form-inlines">
                <el-form-item>
                    <el-date-picker v-model="values" type="daterange" size="small" :clearable="false"
                        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="small" @click="search_day">日对比</el-button>
                    <el-button type="primary" size="small" @click="submitTime(1)">昨</el-button>
                    <el-button type="primary" size="small" @click="submitTime(3)">3</el-button>
                    <el-button type="primary" size="small" @click="submitTime(7)">7</el-button>
                    <el-button type="primary" size="small" @click="submitTimeBy">本月</el-button>
                    <el-button type="primary" size="small" @click="submitTimeSy">上月</el-button>
                </el-form-item>
                <el-form-item>
                    <el-date-picker v-model="zdb_value1" size="small" type="week" format="yyyy 第 WW 周" ref="week1"
                        placeholder="开始周" value-format="yyyy-MM-dd" :clearable="false" id="week1" class="zwidth">
                    </el-date-picker>
                    <el-date-picker v-model="zdb_value2" size="small" type="week" format="yyyy 第 WW 周" ref="week2"
                        placeholder="结束周" value-format="yyyy-MM-dd" :clearable="false" id="week2" class="zwidth">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" type="primary" @click="search_week">周对比</el-button>
                </el-form-item>
                <el-form-item>
                    <el-date-picker v-model="ydb_value1" size="small" type="month" placeholder="开始月" class="ywidth"
                        value-format="yyyy-MM" :clearable="false" id="month1"></el-date-picker>
                    <el-date-picker v-model="ydb_value2" size="small" type="month" placeholder="结束月" class="ywidth"
                        value-format="yyyy-MM" :clearable="false" id="month2"></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" type="primary" @click="search_month">月对比</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" v-loading="loading" border :height="Heighttab" ref="table">
                <el-table-column prop="time" label="日期" align="center"></el-table-column>
                <el-table-column prop="mall_vis" label="商城访客数" align="center"></el-table-column>
                <el-table-column prop="mall_click" label="商城浏览量" align="center"></el-table-column>
                <el-table-column prop="goods_vis" label="商品访客数" align="center"></el-table-column>
                <el-table-column prop="goods_click" label="商品浏览量" align="center"></el-table-column>
                <el-table-column prop="goods_vis_count" label="被访问商品数量" align="center"></el-table-column>

            </el-table>
        </div>
    </div>
</template>

<script>
    import {
        mapState
    } from 'vuex'

    export default {
        props: ['mall_Flow'],
        data() {
            return {
                values: [],
                zdb_value1: '',
                zdb_value2: '',
                ydb_value1: '',
                ydb_value2: '',
                loading: false,
                header: [],
                tableData: [],
                Heighttab: null,
                yhzl: [{
                    title: "实时数据",
                    desc: "",
                    list: [{
                            name: "商城访客数",
                            value: "0"
                        },
                        {
                            name: "商城浏览量",
                            value: "0"
                        },
                        {
                            name: "商品访客数",
                            value: "0"
                        },
                        {
                            name: "商品浏览量",
                            value: "0"
                        },
                        {
                            name: "被访问商品数",
                            value: "0"
                        },


                    ]
                }, ],
            }
        },
        watch: {
            'mall_Flow'(n, o) {
                this.yhzl[0].list[0].value = n.mall_vis ? n.mall_vis : '0'
                this.yhzl[0].list[1].value = n.mall_click ? n.mall_click : '0'
                this.yhzl[0].list[2].value = n.goods_vis ? n.goods_vis : '0'
                this.yhzl[0].list[3].value = n.goods_click ? n.goods_click : '0'
                this.yhzl[0].list[4].value = n.goods_vis_count ? n.goods_vis_count : '0'
            }
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        filters: {
            getCol(total) {
                return `col-${12/total}`;
            }
        },
        mounted() {
            let that = this;
            this.getdata()
            that.gettime();
            that.getheight();
        },
        methods: {
            getdata(t) {
                axios.post('/admin/pc/report/mallFlow', {}, {
                    token: true
                }).then(res => {
                    if (res.data.code == 200) {
                        if (t == 1) {
                            this.$message.success('刷新成功！')
                        }
                    }
                })
            },
         
            gettime() {
                this.submitTime(7);
            },
            getheight() {
                let that = this;
                that.$nextTick(() => {
                    var titles = that.$refs.titles.offsetHeight
                    that.Heighttab = window.innerHeight - titles - 135 + 'px'
                    window.onresize = () => {
                        var titles = that.$refs.titles.offsetHeight
                        that.Heighttab = window.innerHeight - titles - 135 + 'px'
                    };
                })
            },

            search_day() {
                let that = this;
                that.loading = true
                that.header = [];
                that.tableData = [];
                axios.post("/admin/pc/report/mallVis", {
                        start_time: that.values[0],
                        end_time: that.values[1],
                        time_type: '1',
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.tableData = response.data.data
                        that.$nextTick(() => {
                            that.$refs.table.doLayout();
                        });
                    })
                    .catch(error => {})
            },
            search_week() {
                let that = this;
                var week1 = this.$refs.week1.displayValue
                var week2 = this.$refs.week2.displayValue
                that.header = [];
                that.tableData = [];
                if (week1 && week2) {
                    that.loading = true
                    var w1 = (week1.split('第 '))[1];
                    w1 = w1.split(' 周')[0];
                    var w2 = (week2.split('第 '))[1];
                    w2 = w2.split(' 周')[0];
                    axios.post("/admin/pc/report/mallVis", {
                            start_time: that.zdb_value1,
                            end_time: that.zdb_value2,
                            time_type: '3',
                        }, {
                            token: true
                        })
                        .then(response => {
                            that.loading = false

                            that.tableData = response.data.data
                            that.$nextTick(() => {
                                that.$refs.table.doLayout();
                            });
                        })
                        .catch(error => {})
                } else {
                    this.$message({
                        showClose: true,
                        message: '请先选择第几周',
                        type: 'warning'
                    });
                }
            },
            search_month() {
                let that = this;
                that.loading = true
                that.header = [];
                that.tableData = [];
                if (this.ydb_value1 && this.ydb_value2) {
                    axios.post("/admin/pc/report/mallVis", {
                            start_time: that.ydb_value1,
                            end_time: that.ydb_value2,

                            time_type: '2',
                        }, {
                            token: true
                        })
                        .then(response => {
                            that.loading = false

                            that.tableData = response.data.data
                            that.$nextTick(() => {
                                that.$refs.table.doLayout();
                            });
                        })
                        .catch(error => {})
                } else {
                    that.loading = false
                    this.$message({
                        showClose: true,
                        message: '请先选择月份',
                        type: 'warning'
                    });
                }
            },
            //获取n天前时间
            submitTime(n) {
                //开始时间
                var nowDate = new Date();
                let befDate = new Date(nowDate.getTime() - n * 24 * 3600 * 1000);
                let byear = befDate.getFullYear();
                let bmonth = befDate.getMonth() + 1;
                if (bmonth >= 1 && bmonth <= 9) {
                    bmonth = "0" + bmonth;
                }
                let bday = befDate.getDate();
                if (bday >= 0 && bday <= 9) {
                    bday = "0" + bday;
                }
                //截止时间
                let endDate = new Date(nowDate.getTime() - 1 * 24 * 3600 * 1000);
                let year = endDate.getFullYear();
                let month = endDate.getMonth() + 1;
                if (month >= 1 && month <= 9) {
                    month = "0" + month;
                }
                let day = endDate.getDate();
                if (day >= 0 && day <= 9) {
                    day = "0" + day;
                }

                //赋值
                let that = this;
                that.values = [
                    byear + "-" + bmonth + "-" + bday,
                    year + "-" + month + "-" + day
                ];
                that.search_day();
            },
            //本月
            submitTimeBy() {
                let that = this
                var date = new Date();
                var month = parseInt(date.getMonth() + 1);
                var day = date.getDate();
                if (month < 10) month = "0" + month;
                let yuechu = date.getFullYear() + "-" + month + "-" + '01';
                if (day == 1) {
                    that.values = [yuechu, yuechu]
                } else {
                    day = day - 1;
                    if (day < 10) day = "0" + day;
                    let yuedi = date.getFullYear() + "-" + month + "-" + day;
                    that.values = [yuechu, yuedi]
                }
                that.search_day();
            },
            //上月
            submitTimeSy() {
                let nowDate = new Date();
                let year = nowDate.getFullYear();
                let month = nowDate.getMonth();
                nowDate.setDate(0);
                if (month >= 1 && month <= 9) {
                    month = "0" + month;
                }
                let day = nowDate.getDate();
                if (day >= 0 && day <= 9) {
                    day = "0" + day;
                }
                let endTime = `${year}-${month}-${day}`;
                this.nowTime = endTime; // 当前的时间点
                let befDate = new Date(nowDate.getTime());
                let byear = befDate.getFullYear();
                let bmonth = befDate.getMonth() + 1;
                if (bmonth >= 1 && bmonth <= 9) {
                    bmonth = "0" + bmonth;
                }
                let bday = befDate.getDate();
                if (bday >= 0 && bday <= 9) {
                    bday = "0" + bday;
                }
                let startTime = `${byear}-${bmonth}-${bday}`;
                let that = this;
                that.values = [
                    byear + "-" + bmonth + "-" + "01",
                    byear + "-" + bmonth + "-" + day
                ];
                that.search_day();
            },
        },

    }
</script>

<style lang="scss" scoped>
    .tiptit {
        font-size: 18px;
        font-weight: 600;
    }

    .ssbtns {
        background-color: #f5f7fd;
    }

    .tiplist {
        max-width: calc(100% / 5);
        position: relative;
        width: 100%;
        padding-right: 15px;
        padding-left: 15px;
    }

    .numbs {
        font-size: 20px;
        font-weight: 600;
        text-align: center;
        color: #5473e8;
    }

    .shuaxin_icon {
        margin-left: 10px;
    }

    .widthfixs {
        width: 160px !important;
    }

    .red {
        color: red;
    }
</style>